import styled from "styled-components";

/**
 * 날짜 입력 공용 프리미티브 (type="date").
 *
 * 폭/테두리/마진이 다른 화면은 styled(DateInput)`...`로 확장해 사용한다.
 * @prop $default - true면 날짜 텍스트를 흐리게(미선택 placeholder 느낌) 표시.
 * @prop disabled - true면 회색/흐림 처리하고 입력을 막는다.
 */
export const DateInput = styled.input`
  width: 133px;
  height: 35px;
  border-radius: 2px;
  border: 1px solid var(--admin-gray-stroke, #e8e8e8);
  padding: 2px 8px;
  font-family: "Noto Sans KR";

  &:focus {
    outline: none;
  }

  &::-webkit-datetime-edit {
    opacity: ${({ $default }) => ($default ? 0.2 : 1)};
  }

  &:disabled {
    background: var(--admin-gray-disabled-bg, #f5f5f5);
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export default DateInput;
